<div class="sidemenu-wrapper sidemenu-info ">
    <div class="sidemenu-content">
        <button class="closeButton sideMenuCls">
            <i class="far fa-times"></i>
        </button>
        <div class="widget  ">
            <div class="th-widget-about">
                <div class="about-logo">
                    <a routerLink="/"><img src="assets/img/logo.png" alt="XipeTech" style="max-width:50%;"></a>
                </div>
                <p class="about-text">Xipe Tech is a Technological solutions company providing the best kind of IT
                    services for your business with utmost professionalism. Here in Xipe Tech we believe in the
                    philosophy that each punch of a boxer must be stronger than the last one.</p>
                <div class="th-social">
                    <a href="https://www.facebook.com/xipetech/"><i class="fab fa-facebook-f"></i></a>
                    <a href="https://x.com/xipetech/"><i class="fab fa-twitter"></i></a>
                    <a href="https://www.linkedin.com/company/xipe-tech/"><i class="fab fa-linkedin-in"></i></a>
                    <a href="https://www.instagram.com/xipe.tech/"><i class="fab fa-instagram"></i></a>
                    <a href="https://www.youtube.com/@XipeTechLucknow"><i class="fab fa-youtube"></i></a>
                </div>
            </div>
        </div>
        <div class="widget">
            <h3 class="widget_title">Get In Touch</h3>
            <div class="th-widget-contact">
                <div class="info-box_text">
                    <div class="icon">
                        <img src="assets/img/icon/phone.svg" alt="img">
                    </div>
                    <div class="details">
                        <p><a href="tel:+918090920216" class="info-box_link">+91-8090-920216</a></p>
                    </div>
                </div>
                <div class="info-box_text">
                    <div class="icon">
                        <img src="assets/img/icon/envelope.svg" alt="img">
                    </div>
                    <div class="details">
                        <p><a href="mailto:hr@xipetech.com" class="info-box_link">hr&#64;xipetech.com</a></p>
                        <p><a href="mailto:support@xipetech.com" class="info-box_link">support&#64;xipetech.com</a></p>
                    </div>
                </div>
                <div class="info-box_text">
                    <div class="icon"><img src="assets/img/icon/location-dot.svg" alt="img"></div>
                    <div class="details">
                        <p><a href="https://maps.app.goo.gl/oaZs8hQLAYRGCyiN9" target="_blank">1st Floor, 529C/486,
                                Kamla Nehru Nagar, <br>Jageshwarpuri, Shankar
                                Purva-Ⅲ, Zone 7,
                                <br>Lucknow - 226022 Uttar Pradesh, India
                                Landmark: XT Building</a></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="popup-search-box">
    <button class="searchClose"><i class="fal fa-times"></i></button>
    <form action="#">
        <input type="text" placeholder="What are you looking for?">
        <button type="submit"><i class="fal fa-search"></i></button>
    </form>
</div>
<!--============================== Mobile Menu ============================== -->
<div class="th-menu-wrapper onepage-nav">
    <div class="th-menu-area text-center">
        <button class="th-menu-toggle"><i class="fal fa-times"></i></button>
        <div class="mobile-logo">
            <a routerLink="/"><img src="assets/img/logo_white-1.png.webp" alt="XipeTech"></a>
        </div>
        <div class="th-mobile-menu">
            <ul>
                <li class="menu">
                    <a routerLink="/">Home</a>
                </li>
                <li class="menu">
                    <a routerLink="/about-us">About Us</a>
                </li>
                <li class="menu">
                    <a routerLink="/services">Our Services</a>
                </li>
                <li class="menu">
                    <a routerLink="/our-projects">Our Projects</a>
                </li>
                <li class="menu">
                    <a routerLink="/careers">Careers</a>
                </li>
                <li class="menu">
                    <a routerLink="/latest-news">Latest News</a>
                </li>
                <li class="menu">
                    <a routerLink="/contact">Contact Us</a>
                </li>
            </ul>
        </div>
    </div>
</div>
<!--============================== Header Area    ==============================-->
<header class="th-header header-layout3 header-absolute">
    <div class="sticky-wrapper">
        <!-- Main Menu Area -->
        <div class="menu-area">
            <div class="header-button d-none d-xl-block">
                <button type="button" class="icon-btn icon-svg searchBoxToggler">
                    <img src="assets/img/icon/search.svg" alt="icon">
                </button>
            </div>
            <div class="container">
                <div class="row align-items-center justify-content-between">
                    <!-- <div class="col-auto d-none d-xl-block">
                        <button type="button" class="icon-btn icon-svg searchBoxToggler">
                            <img src="assets/img/icon/search.svg" alt="icon">
                        </button>
                    </div>  -->
                    <div class="col-auto d-none d-xl-block">
                        <nav class="main-menu">
                            <ul>
                                <li class="menu">
                                    <a routerLink="/about-us">About Us</a>
                                </li>
                                <li class="menu">
                                    <a routerLink="/services"> Our Services</a>
                                </li>
                                <li class="menu">
                                    <a routerLink="/our-projects">Our Projects</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-auto">
                        <div class="header-logo">
                            <a routerLink="/">
                                <img src="assets/img/logo_white-1.png.webp" alt="XipeTech" />
                            </a>
                        </div>
                    </div>
                    <div class="col-auto d-none d-xl-block">
                        <nav class="main-menu">
                            <ul>
                                <li class="menu">
                                    <a routerLink="/careers">Careers</a>
                                </li>
                                <li class="menu">
                                    <a routerLink="/latest-news">Latest News</a>
                                </li>
                                <li class="menu">
                                    <a routerLink="/contact"> Contact Us</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="col-auto">
                        <div class="header-right-button">
                            <button type="button" class="th-menu-toggle d-block d-xl-none"><i
                                    class="far fa-bars"></i></button>
                            <button class="simple-icon sideMenuToggler d-none d-xl-block">
                                <img src="assets/img/icon/menu.svg" alt="icon">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>